export function getAttribute (record, attributeName) {
  if (typeof record.attributes === 'undefined') {
    return null
  }

  return record.attributes.reduce((result, attribute) => {
    if (attribute.attributeName === attributeName) {
      return attribute.attributeValue
    } else {
      return result
    }
  }, null)
}



// WEBPACK FOOTER //
// ./src/api/Util.js